export default __webpack_public_path__ + "b0852c6ba5055db9bd41b04e2eabf9a9.png";